/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Nomatch2Inputs */

const zh_adminsubs_nomatch2 = /** @type {(inputs: Adminsubs_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到匹配的订阅`)
};

const en_adminsubs_nomatch2 = /** @type {(inputs: Adminsubs_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching subscriptions found`)
};

const es_adminsubs_nomatch2 = /** @type {(inputs: Adminsubs_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron suscripciones`)
};

/**
* | output |
* | --- |
* | "No matching subscriptions found" |
*
* @param {Adminsubs_Nomatch2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_nomatch2 = /** @type {((inputs?: Adminsubs_Nomatch2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Nomatch2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_nomatch2(inputs)
	if (locale === "en") return en_adminsubs_nomatch2(inputs)
	return es_adminsubs_nomatch2(inputs)
});
export { adminsubs_nomatch2 as "adminSubs_noMatch" }